import PageList from './PageList';

export default PageList;